module.exports = __webpack_public_path__ + "img/favoriteOff.865c5f71.svg";